import React from "react";
import "./InputGlobal.scss";

function InputGlobal({
  placeholder,
  className,
  name,
  type,
  onChange,
  value,
  autoComplete,
  onFocus,
  onBlur,
}) {
  return (
    <input
      autoComplete={autoComplete ? autoComplete : "off"}
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
}

export default InputGlobal;
